import { render, staticRenderFns } from "./status.vue?vue&type=template&id=aa07904e&"
import script from "./status.vue?vue&type=script&lang=ts&setup=true&"
export * from "./status.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports